import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormSelect from "../../../../../components/atoms/Select";
import PageTable from "../../../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../../../components/atoms/ActionsIcons";
import { faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import { handleFind, isNullOrUndefinded } from "../../../../../helper/utils";
import { EstadoBadge } from "./gestorCasosStyles";
import { useManagePostRequest } from "../../../../../hooks/useManagePostRequest/useManagePostRequest";

import DetalleNotaModal from "./modales/DetalleNotaModal";
import DetalleObservacionModal from "./modales/DetalleObservacionModal";
import DetalleSolicitudCambioModal from "./modales/DetalleSolicitudCambioModal";
import DetalleAlertaConfiguracionModal from "./modales/DetalleAlertaConfiguracionModal";
import DetalleCargaHorariaModal from "./modales/DetalleCargaHorariaModal";
import MensajeConfirmacionEliminarCasoModal from "./modales/MensajeConfirmacionEliminarCasoModal";

import { cuadroRequerimientosEliminarCaso } from "../../../../../consumers/backendApisUrls";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  return new Intl.DateTimeFormat("es-ES", {
    day: "numeric",
    month: "short",
  })
    .format(date)
    .toLowerCase();
};

const getDetalleModalComponent = (tipoCaso) => {
    console.log("tipoCaso", tipoCaso)
  const tipoMap = {
    Nota: DetalleNotaModal,
    Observación: DetalleObservacionModal,
    "Solicitud de Cambio": DetalleSolicitudCambioModal,
    "Alerta de Configuración": DetalleAlertaConfiguracionModal,
    "Carga Horaria": DetalleCargaHorariaModal,
  };
  return tipoMap[tipoCaso] || DetalleNotaModal;
};

const TableGestorCasos = ({
  formValues,
  setFormValues,
  extraData,
  setModalEnabled,
  paginator,
  setPaginator,
  keys: KEYS,
  manageSearch,
  idCuadroSede,
}) => {
  const [rows, setRows] = useState([]);
  const [executePost] = useManagePostRequest();

  useEffect(() => {
    if (!isNullOrUndefinded(formValues?.Items)) setRows(formValues.Items);
  }, [formValues.Items]);

  const handleFilterSelected = (res, key) => {
    const updatedSelectedFilters = {
      ...formValues.selectedFilters,
      [key]: res,
    };
    setFormValues((last) => ({
      ...last,
      selectedFilters: updatedSelectedFilters,
    }));
  };

  const handleViewDetail = (row) => {
    const DetalleModal = getDetalleModalComponent(row.TipoCaso);
    setModalEnabled({
      isEnable: true,
      component: DetalleModal,
      data: {
        casoData: row,
        refreshPage: manageSearch,
        idCuadroSede: idCuadroSede,
      },
    });
  };
  const handleEliminarCaso = async (idCaso) => {
    try {
      await executePost(
        cuadroRequerimientosEliminarCaso(),
        { IdCaso: idCaso },
        () => {
          manageSearch();
        },
      );
    } catch (error) {
      console.error("Error al bloquear empleado:", error);
    }
  };

  const HEADERS = [
    { col: "col-sm-1", label: "Fecha", className: "text-left" },
    {
      col: "col-sm-2",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, KEYS.IdsTiposCaso)}
            description="Tipo"
            selectedOptions={
              formValues.selectedFilters?.[KEYS.IdsTiposCaso] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, KEYS.IdsTiposCaso)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-2", label: "Referencia" },
    { col: "col-sm-3", label: "Tema" },
    { col: "col-sm-3", label: "Estado Caso" },
    {
      col: "col-sm-2",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, KEYS.IdsEstados)}
            description="Estado Resolución"
            selectedOptions={
              formValues.selectedFilters?.[KEYS.IdsEstados] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, KEYS.IdsEstados)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-1", label: "Acción" },
  ];

  return (
    <PageTable
      headers={HEADERS}
      paginator={paginator}
      setPaginator={setPaginator}
    >
      <tbody className="listar-tbody">
        {rows.map((row) => (
          <tr key={row.IdCaso}>
            <td className="text-left">{formatDate(row.FechaRegistro)}</td>

            <td className="text-left">{row.TipoCasoLabel ?? row.TipoCaso}</td>

            <td className="text-left">{row.Referencia || "–"}</td>
            <td>{row.Tema}</td>

            <td className="text-center">{row.EstadoCaso}</td>

            <td className="text-left">
              <EstadoBadge estado={row.EstadoResolucion}>
                {row.EstadoResolucion}
              </EstadoBadge>
            </td>

            <td>
              <ActionsIcons>
                <FontAwesomeIcon
                  icon={faEye}
                  title="Ver"
                  size="md"
                  style={{ marginRight: "auto" }}
                  onClick={() => handleViewDetail(row)}
                />
                {row.PuedeEliminar && (
                  <FontAwesomeIcon
                    icon={faTrash}
                    title="Eliminar"
                    size="md"
                    style={{ marginLeft: "auto" }}
                    onClick={() => {
                      setModalEnabled({
                        isEnable: true,
                        component: MensajeConfirmacionEliminarCasoModal,
                        data: {
                          idCaso: row.IdCaso,
                          handleEliminarCaso: handleEliminarCaso,
                        },
                      });
                    }}
                  />
                )}
              </ActionsIcons>
            </td>
          </tr>
        ))}
      </tbody>
    </PageTable>
  );
};

export default TableGestorCasos;
